import { render, staticRenderFns } from "./StandardHeader.vue?vue&type=template&id=2e165448"
import script from "./StandardHeader.vue?vue&type=script&lang=js"
export * from "./StandardHeader.vue?vue&type=script&lang=js"
import style0 from "./StandardHeader.vue?vue&type=style&index=0&id=2e165448&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports